module.exports = __webpack_public_path__ + "img/GB-UKM.33ea0ad3.svg";